export const APP_NAME = 'mml-pwa';
